module.exports = __webpack_public_path__ + "static/services_bg-03ec7672e7dcba334cd76f3f1a179c12.jpg";